export const PARAM = {
  TRAFFIC_SOURCE: "filterTrafficSource",
  COUNTRY: "filterCountry",
  CAMPAIGN_ID: "filterCampaignId",
  CAMPAIGN_NAME: "filterCampaignName",
  ADGROUP_ID: "filterAdGroupId",
  ADGROUP_NAME: "filterAdGroupName",
  KEYWORD_ID: "filterKeywordId",
  KEYWORD_NAME: "filterKeywordName",
} as const;
export const removeTrendParams = (searchParams: URLSearchParams) => {
  const updated = new URLSearchParams(searchParams.toString());

  Object.values(PARAM).forEach((key) => {
    updated.delete(key);
  });

  return updated;
};
